import { objectLessAttributes } from '@aws-amplify/core';
import React, { Component } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LoadStatusNavItem from './LoadStatusNavItem';
import { injectIntl } from 'react-intl';
import { ReactComponent as UnbilledIcon } from '../../../../assets/images/Unbilled.svg';
import { ReactComponent as BilledIcon } from '../../../../assets/images/Billed.svg';
import { ReactComponent as CompletedIcon } from '../../../../assets/images/Completed.svg';
class LoadStatusNav extends Component {

    constructor(props) {
        super(props);
        this.state = {
            intl: this.props.intl,
            activeOrder: 1,
            items: [
                {
                    name: this.props.intl.formatMessage({ id: "app.awaiting_header" }),
                    key: 1,
                    badge: this.props.unbilledLoadsCount || 0,
                    order: 1,
                    title: this.props.intl.formatMessage({ id: "app.load_status_awaiting_tooltip" }),
                    css: <UnbilledIcon />,
                    id:"unbilled",
                    className: "react_tour_step_10"
                },
                {
                    name: this.props.intl.formatMessage({ id: "app.payment_due_header" }),
                    key: 2,
                    badge: this.props.billedLoadsCount || 0,
                    order: 2,
                    title: this.props.intl.formatMessage({ id: "app.load_status_payment_due_tooltip" }),
                    css: <BilledIcon />,
                    id:"billed",
                    className: "react_tour_step_11"

                },
                {
                    name: this.props.intl.formatMessage({ id: "app.completed_header" }),
                    key: 3,
                    badge: this.props.completedLoadsCount || 0,
                    order: 3,
                    title: this.props.intl.formatMessage({ id: "app.load_status_completed_tooltip" }),
                    css: <CompletedIcon />,
                    id:"complete",
                    className: "react_tour_step_12"
                },
            ]
        }

    }


    static getDerivedStateFromProps(nextProps, prevState) {
        let flag = false;
        let itemsObject = {};
        let items=[];

        if (nextProps.unbilledLoadsCount !== prevState.items[0]?.badge || nextProps.billedLoadsCount !== prevState.items[1]?.badge || nextProps.completedLoadsCount !== prevState.items[2]?.badge) {
            items = prevState.items.map(obj => {
                if (obj.key === 3)
                    Object.assign(obj, { badge: nextProps.completedLoadsCount || 0 });
                else if (obj.key === 2)
                    Object.assign(obj, { badge: nextProps.billedLoadsCount || 0 });
                else
                    Object.assign(obj, { badge: nextProps.unbilledLoadsCount || 0 });
                return obj;
                
            })
            flag = true;
            // <- this is setState equivalent
        }

        if (nextProps.intl.locale !== prevState.intl.locale) {
            items = prevState.items.map(obj => {
                if (obj.key === 3)
                    Object.assign(obj, { name: nextProps.intl.formatMessage({ id: "app.completed_header" }), title: nextProps.intl.formatMessage({ id: "app.load_status_completed_tooltip" }) });
                else if (obj.key === 2)
                    Object.assign(obj, { name: nextProps.intl.formatMessage({ id: "app.payment_due_header" }), title: nextProps.intl.formatMessage({ id: "app.load_status_payment_due_tooltip" }) });
                else
                    Object.assign(obj, { name: nextProps.intl.formatMessage({ id: "app.awaiting_header" }), title: nextProps.intl.formatMessage({ id: "app.load_status_awaiting_tooltip" }) });
                return obj;
                
            })
            flag = true;
        }
        itemsObject.items=items;
        itemsObject.intl=nextProps.intl;

        return flag ? itemsObject : null;
    }
    

    onItemClick = (order) => {
        this.setState({ activeOrder: order });
        this.props.clickedComponentOrder(order);
    }

    render() {
        const { items, activeOrder } = this.state;

        return (

            <div className="border-bottom bg-white nav-tab-pt">
                <ul className="nav nav-pills" id="View-manageContests" role="tablist">
                    {
                        items.map((item) => {
                            return (
                                <LoadStatusNavItem
                                    path={item.path}
                                    name={item.name}
                                    onItemClick={this.onItemClick}
                                    active={item.order === activeOrder}
                                    key={item.key}
                                    badge={item.badge}
                                    order={item.order}
                                    title={item.title}
                                    css={item.css}
                                    id={item.id}
                                    className={item.className}

                                />
                            );
                        })
                    }
                </ul>
            </div >
        )
    }
}

const RouterSideNav = withRouter(injectIntl(LoadStatusNav));


export default class LoadStatusNavBar extends Component {
    render() {
        return (
            <RouterSideNav
                clickedComponentOrder={this.props.clickedComponentOrder}
                billedLoadsCount={this.props.billedLoadsCount}
                unbilledLoadsCount={this.props.unbilledLoadsCount}
                completedLoadsCount={this.props.completedLoadsCount} />
        );
    }
}

